/**
 * @file index.tsx
 *
 * @fileoverview Renders a cobranded gateway.
 */
import Image from '~/jobiqo/components/Image';
import { CobrandedGatewayParagraph } from '~/jobiqo/types/types';
import styles from './cobrandedGateway.module.scss';
import { Box } from '~/vcl/atoms/07-box';
import { FlexItems } from '~/vcl/atoms/06-layout/03-flex';
import { FlexItem } from '~/vcl/atoms/06-layout/03-flex/02-flex-item';
import { WYSIWYGText } from '~/vcl/atoms/13-text/02-WYSIWYG';

export interface CobrandedGatewayProps {
  /**
   * The cobranded gateway data.
   */
  row: {
    /**
     * The content to display.
     */
    content: string;
  } & CobrandedGatewayParagraph;
}

export default function CobrandedGateway({
  row: { content, logo },
}: CobrandedGatewayProps) {
  return (
    <Box
      boxShadow="none"
      borderRadius="0px"
      paddingTop={[9, 11]}
      paddingBottom={[9, 11]}
      paddingLeft={[6, 12]}
      paddingRight={[6, 12]}
      marginTop={0}
      backgroundColor="white"
    >
      <FlexItems gap={[2, 9]} flexDirection={['column', 'row']}>
        <FlexItem className={styles.imageWrapper}>
          <Image
            alt={logo.alt ?? ''}
            src={logo.url}
            width={logo.width}
            height={logo.height}
          />
        </FlexItem>
        <FlexItem>
          {<WYSIWYGText format="full_html" content={content} />}
        </FlexItem>
      </FlexItems>
    </Box>
  );
}

export { CobrandedGateway };
